/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

Swiper.use([Navigation, Autoplay]);

export function sliders() {
    const latestCasesSliderselector = ".cases-component__cases-container.swiper";
    const latestArticlesSliderselector = ".news-items.swiper";
    const logoSliderSelector = ".references__slider.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {
        // Latest Cases sliders
        const latestCasesSliders = [];
        const latestCasesSlidersElements = document.querySelectorAll(latestCasesSliderselector);
        if (latestCasesSlidersElements) {
            latestCasesSlidersElements.forEach(slider => {
                latestCasesSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        el: ".slider-navigation",
                        clickable: true,
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            });
        }

        // Latest Articles sliders
        const latestArticlesSliders = [];
        const latestArticlesSlidersElements = document.querySelectorAll(latestArticlesSliderselector);
        if (latestArticlesSlidersElements) {
            latestArticlesSlidersElements.forEach(slider => {
                latestArticlesSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        el: ".slider-navigation",
                        clickable: true,
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 3.2,
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            });
        }

                // Logo Slider
                const logoSlider = [];
                const logoSliderElements = document.querySelectorAll(logoSliderSelector);
                if (logoSliderElements) {
                    logoSliderElements.forEach(slider => {
        
                        logoSlider.push(new Swiper(slider, {
                            speed: 3000,
                            loop: true,
                            freeMode: true,
                            allowTouchMove: false,
                            slidesPerView: 2.5,
                            spaceBetween: 30,
                            autoplay: {
                                delay: 0.5,
                            },
                            breakpoints: {
                                // when window width is >= 768px
                                1440: {
                                    slidesPerView: 4,
                                },
                                992: {
                                    slidesPerView: 4,
                                    spaceBetween: 45,
                                },
                            },
                            on: {
                                slideChange: () => {
                                    handleSlideChange();
                                },
                                slideChangeTransitionEnd: (swiper) => {
                                    handleSlideChangeTransitionEnd(swiper);
                                }
                            }
                        }));
                    })
                }
    }

    init();

}

export function slider() {
    const sliderSelector = ".slider__slider";

    // $breakpoint-M scss variable
    const breakpointM = 768;


    const setSliderNavigationColor = function () {
        var currentSlide = document.querySelector(".swiper-slide-active");
        if (currentSlide != null) {
            let slideArrowColor = currentSlide.dataset.arrowcolor;
            console.log(slideArrowColor);
            if (typeof slideArrowColor == "undefined") {
                slideArrowColor = currentSlide.querySelector('.image-item__text').dataset.arrowcolor;
            }
            const sliderNavigation = currentSlide.closest(sliderSelector).querySelector(".slider__navigation");
            if (sliderNavigation != null) {
                sliderNavigation.className = "slider__navigation slider__navigation--color-" + slideArrowColor; //Way easier than using classlist.
            }
        }
    }

    const init = function () {
        var slider = new Swiper(sliderSelector, {
            speed:500,
            loop: false,
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            navigation: {
                prevEl: '.button-prev',
                nextEl: '.button-next'
            },
            on: {
                init: () => {
                    setSliderNavigationColor();
                },
                slideChangeTransitionStart: () => {
                    setSliderNavigationColor();
                }
            }
        });

        const setSliderImageItemsEqualHeight = () => {
            const sliderElements = Array.from(document.querySelectorAll('.slider'));
            if(sliderElements) {
                const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                sliderElements.forEach(sliderElement => {
                    const imageItems = Array.from(sliderElement.querySelectorAll('.image-item'));
                    if(imageItems) {
                        const heights = imageItems.map(x => x.clientHeight);
                        const heightOfHeighest = Math.max(...heights);
                        imageItems.forEach(imageItem => {
                            imageItem.style.height = `${heightOfHeighest}px`;
                            if(vw >= breakpointM) {
                                imageItem.style.height = 'unset';
                            }
                        });
                    }
                });
            }
        }

        let setSliderImageHeightTimer;
        window.addEventListener('resize', () => {
            clearTimeout(setSliderImageHeightTimer);
            setSliderImageHeightTimer = setTimeout(setSliderImageItemsEqualHeight, 100);
        });
        setSliderImageItemsEqualHeight();

    };

    init();
}